import API from './API';
import urls from './urls';
import config from '../config';

let api = new API({ url: config.api.baseUrl });
api.createEntities(urls)

export default api.endpoints;